module.exports = __webpack_public_path__ + "assets/img/main-logo-xingtai.6871c4f9.png";